import React from 'react';
import { useDispatch } from 'react-redux';

import { Button } from 'js/components/common/Button';

import { useOnClose } from 'js/components/common/PopupManager';
import { componentService } from 'js/services/component.service';
import { setJumioStatus, setJumioStep } from 'js/hooks/user/store/buzz/actions';

import style from './ButtonShowUnverifiedPlayerPopup.scss';

export const ButtonShowUnverifiedPlayerPopup = ({ children }) => {
    const dispatch = useDispatch();
    const closeManagedPopup = useOnClose();

    const handlerOpenPopup = () => {
        closeManagedPopup();
        dispatch(setJumioStatus('gracePeriod'));
        dispatch(setJumioStep('gracePeriod'));
    };

    return (
        <Button
            onClick={handlerOpenPopup}
            className={style.btn}
        >
            {children}
        </Button>
    );
};

componentService.registerWebContentComponents({ ShowUnverifiedPlayerPopup: ButtonShowUnverifiedPlayerPopup });
